module.exports = __webpack_public_path__ + "static/media/dark_blue-p.39b1bb09.svg";